
import { Menu, X } from "lucide-react";

interface MobileMenuButtonProps {
  isOpen: boolean;
  onClick: () => void;
}

export const MobileMenuButton = ({ isOpen, onClick }: MobileMenuButtonProps) => {
  return (
    <button onClick={onClick} className="text-gray-100">
      {isOpen ? <X size={24} /> : <Menu size={24} />}
    </button>
  );
};
